<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <slot />
            <VaAvatar :size="32" color="primary"> <VaIcon :size="30" name="account_circle" /></VaAvatar>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content md:w-60 px-0 py-4 w-full"
        :style="{ '--hover-color': hoverColor }"
      >
        <div class="px-4 pb-4">
          <div style="color: var(--va-primary)" class="flex gap-2">
            <VaAvatar :size="24" color="primary">
              <VaIcon :size="25" name="account_circle" />
            </VaAvatar>
            <div>
              <h3>
                <span class="va-h6">{{ user?.firstName }} {{ user?.lastName }}</span>
              </h3>
              <span class="text-xs">{{ user?.email }}</span>
            </div>
          </div>
        </div>
        <VaList>
          <header class="uppercase text-[var(--va-secondary)] opacity-80 font-bold text-xs px-4">Explore</header>
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" :to="{ name: 'FAQ' }">
            <VaIcon name="quiz" class="pr-1" color="secondary" />
            FAQ
          </VaListItem>
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" :to="{ name: 'services' }">
            <VaIcon name="home" class="pr-1" color="secondary" />
            Services
          </VaListItem>
          <VaListSeparator class="mx-3 my-2" />
        </VaList>

        <VaList>
          <header class="uppercase text-[var(--va-secondary)] opacity-80 font-bold text-xs px-4">Account</header>
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" :to="{ name: 'settings' }">
            <VaIcon name="manage_accounts" class="pr-1" color="secondary" />
            Settings
          </VaListItem>
          <VaListSeparator class="mx-3 my-2" />
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" :to="{ name: 'logout' }">
            <VaIcon name="logout" class="pr-1" color="secondary" />
            Sign out
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import {
  useColors,
  VaAvatar,
  VaButton,
  VaDropdown,
  VaDropdownContent,
  VaIcon,
  VaList,
  VaListItem,
  VaListSeparator,
} from 'vuestic-ui'
import { JWTDecodedModel, User } from '@services/authentication'

defineProps<{
  user: User | JWTDecodedModel | null
}>()

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const isShown = ref(false)
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
